const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgeCazaCopy = async (id_caza: string, aules: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${id_caza}/copy`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ aules })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al copiar píldora:', error);
    }
};
